/**
 * @generated SignedSource<<42501dd258b0f4845936753628f33884>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Row996BadPattern$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Row329BadPattern" | "Row416BadPattern" | "Row481BadPattern" | "Row519BadPattern" | "useRowColor">;
  readonly " $fragmentType": "Row996BadPattern";
};
export type Row996BadPattern$key = {
  readonly " $data"?: Row996BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"Row996BadPattern">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "isConditionalFormattingEnabled",
    "variableName": "isConditionalFormattingEnabled"
  },
  {
    "kind": "Variable",
    "name": "isDensityFull",
    "variableName": "isDensityFull"
  },
  {
    "kind": "Variable",
    "name": "isInlineEditingEnabled",
    "variableName": "isInlineEditingEnabled"
  },
  {
    "kind": "Variable",
    "name": "isLinkRelationshipFieldEnabled",
    "variableName": "isLinkRelationshipFieldEnabled"
  },
  {
    "kind": "Variable",
    "name": "isTimelineEnabled",
    "variableName": "isTimelineEnabled"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isLinkRelationshipFieldEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isTimelineEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "Row996BadPattern",
  "selections": [
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "Row481BadPattern"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "Row416BadPattern"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "Row519BadPattern"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "Row329BadPattern"
    },
    {
      "condition": "isConditionalFormattingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "useRowColor"
        }
      ]
    }
  ],
  "type": "JiraIssueFieldSetConnection"
};
})();

(node as any).hash = "1d35e266d8aca0b9f5ff3c47bd7bba57";

export default node;
